aui-setup {
  --meter-size: 12px;
  overflow: hidden;
  padding-block: var(--padding-sm) var(--padding-xs);
  padding-inline: var(--padding-sm);

  .expanded {
    position: initial;
    button {
      color: var(--color-text);
      min-block-size: 78px;
      padding: var(--padding-sm);
      text-decoration: none;

      &:hover {
        color: var(--color-text);
        text-decoration: none;
      }
    }

    &:hover {
      background-color: var(--color-gray-lightest);
    }

    .setup-header {
      align-items: center;
      display: flex;
      gap: var(--padding-sm);
      justify-content: flex-start;
      padding-block-end: var(--padding-xs);

      s-icon {
        align-items: center;
        display: inline-flex;
      }

      .title {
        padding-inline-start: 0;
      }
    }

    .subtitle {
      color: var(--color-gray-dark);
    }

    .meter-icon-wrapper {
      align-items: center;
      block-size: 36px;
      display: flex;
      flex-direction: column;
      inline-size: 36px;
      justify-content: flex-start;

      padding: var(--padding-xs);

      &:hover {
        background-color: var(--color-gray-lightest);
      }

      meter {
        inline-size: 28px;
        inset-block-start: -4px;
        position: relative;
      }
    }
  }

  .collapsed {
    display: flex;
    justify-content: center;

    button {
      color: var(--color-text);
      display: flex;
      justify-content: center;
      min-block-size: 44px;
      min-inline-size: 44px;
      padding-inline: 0;
      text-decoration: none;

      &:hover {
        color: var(--color-text);
        text-decoration: none;
      }
    }

    .meter-icon-wrapper {
      align-items: center;
      block-size: 36px;
      display: flex;
      flex-direction: column;
      inline-size: 36px;
      justify-content: flex-start;

      padding: var(--padding-xs);

      &:hover {
        background-color: var(--color-gray-lightest);
      }

      meter {
        inline-size: 28px;
        inset-block-start: 2px;
        position: relative;
      }
    }
  }

  meter {
    -moz-appearance: none;
    appearance: none;
    background: transparent;
    block-size: var(--meter-size);
    border-radius: var(--meter-size);
    inline-size: 100%;
    overflow: hidden;

    &::-webkit-meter-bar {
      background: var(--color-gray-lighter);
      block-size: 100%;
      border-radius: var(--meter-size);
    }

    &::-webkit-meter-optimum-value {
      background: var(--color-blue-medium);
      block-size: 100%;
      border-radius: var(--meter-size) 0 0 var(--meter-size);
    }

    &::-moz-meter-bar {
      background: var(--color-blue-medium);
      block-size: 100%;
      border-radius: var(--meter-size) 0 0 var(--meter-size);
    }
  }
}
